@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	--zds-link-color: var(--zds-breadcrumb-color);
	--zds-link-color-hover: var(--zds-breadcrumb-color-hover);
	--zds-link-color-visited: var(--zds-breadcrumb-color);
	--zds-link-text-decoration: var(--zds-breadcrumb-text-decoration);
	--zds-link-text-decoration-hover: var(--zds-breadcrumb-text-decoration-hover);
}

zds-link {
	display: block;
	max-width: 100%;
}

.zds-breadcrumb__text {
	font-size: var(--zds-breadcrumb-font-size);
	max-width: 400px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
